import Styled from 'styled-components';
import { Button } from '../../buttons/buttons';

const ActionButton = Styled(Button)`
  height: ${props => props.size};
  width: ${props => props.size};
  padding: 0;
`;

ActionButton.defaultProps = {
  size: '30px',
};

export { ActionButton };
